import { useCustomQuery } from "data/modules/api/hooks/useCustomQuery";
import { useCustomizationStore } from "../../store/useCustomizationStore";
import { webpage_apis } from "../constants/api.constants";
import { useCallback } from "react";

export const useFetchInitialFormState = () => {
  const setSectionConfig = useCustomizationStore(
    (state) => state.setSectionConfig
  );
  const setSectionConfigLoading = useCustomizationStore(
    (state) => state.setSectionConfigLoading
  );

  const onSuccess = useCallback(
    (data) => {
      setSectionConfig(data);
      setSectionConfigLoading(false);
    },
    [setSectionConfig, setSectionConfigLoading]
  );

  const onSettled = useCallback(() => {
    setSectionConfigLoading(false);
  }, [setSectionConfigLoading]);

  const { isLoading, isFetching, refetch } = useCustomQuery({
    url: webpage_apis.InitialWebpageCustomizationDetails,
    queryKey: [webpage_apis.InitialWebpageCustomizationDetails],
    refetchOnMount: "always",
    onSuccess: onSuccess,
    onSettled: onSettled,
  });

  return { isLoading, isFetching, refetch };
};
